import { Controller } from "@hotwired/stimulus"

// The Preview's editor panel: the pencil on page 1 or page 2 (or a button in
// the side panel) opens it, a native modal <dialog> styled as a sheet on the
// right edge, so the document itself stays plain text.
//
//   <button data-action="page-editor#open" data-page-editor-id-param="page_editor">
//   <dialog id="page_editor" data-page-editor-target="dialog"
//           data-action="keydown->page-editor#key click->page-editor#closeOnBackdrop">
//
// Keys stop at the dialog, as in lightbox_controller.js: the drawer around
// the desk listens on the window, so its Escape would close the whole drawer
// and its Tab trap would reach for controls the modal has made inert.
// Escape closes the panel only.
export default class extends Controller {
  static targets = ["dialog", "saveError"]

  // A refused Save replaces the panel body (a turbo stream) with "Not
  // saved:" at its top, while the panel is scrolled down to the Save button
  // and that button, which had focus, is gone. Bring the message into view
  // and move focus to it, so it is seen and read out.
  saveErrorTargetConnected(element) {
    element.scrollIntoView({ block: "start" })
    element.focus({ preventScroll: true })
  }

  open(event) {
    const dialog = this.dialogTargets.find((target) => target.id === event.params.id)
    if (dialog && !dialog.open) dialog.showModal()
  }

  close(event) {
    event.target.closest("dialog")?.close()
  }

  key(event) {
    event.stopPropagation()
    if (event.key === "Escape") {
      event.preventDefault()
      event.currentTarget.close()
    }
  }

  // The dialog element itself is hit only outside its sheet, on the backdrop.
  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) event.currentTarget.close()
  }
}
